module.exports = __webpack_public_path__ + "img/img-2.c078a206.jpg";